import React from 'react';
import { AntStandardPopup } from 'ante-react-kit';

export default function AntPickerPopup({ visible, onClose, title, subtitle, header, footer, children, width, height, error }) {
    return (
        <AntStandardPopup
            visible={visible}
            onClose={onClose}
            title={title}
            subtitle={subtitle}
            headerExtra={header}
            footer={footer}
            error={error}
            size="lg"
            width={width}
            height={height}
            wrapperClass="ant-picker-popup"
        >
            {children}
        </AntStandardPopup>
    );
}
